var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"text-center"},[_c('h3',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('page_not_found')))]),_c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":{ name: 'login' }}},[_vm._v(" "+_vm._s(_vm.$t('go_home'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }